/**
 * Cookie Consent Utility
 *
 * Uses cookies instead of localStorage to share consent across all subdomains
 * (nexusdialer.com, app.nexusdialer.com, www.nexusdialer.com, etc.)
 */

const CONSENT_COOKIE_NAME = "nexusdialer_cookie_consent";
const CONSENT_COOKIE_DAYS = 365; // 1 year

/**
 * Set a cookie with domain-level sharing
 */
export function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  const hostname = window.location.hostname.toLowerCase();
  const domainAttribute =
    hostname === "nexusdialer.com" || hostname.endsWith(".nexusdialer.com")
      ? ";domain=.nexusdialer.com"
      : "";
  const secureAttribute =
    window.location.protocol === "https:" ? ";Secure" : "";

  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/${domainAttribute};SameSite=Lax${secureAttribute}`;
}

/**
 * Get a cookie value
 */
export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

/**
 * Check whether the user explicitly accepted optional cookies.
 */
export function hasAcceptedCookies() {
  return getCookie(CONSENT_COOKIE_NAME) === "accepted";
}

/**
 * Check whether optional analytics may be enabled.
 */
export function isAnalyticsEnabled() {
  return getCookie(CONSENT_COOKIE_NAME) === "accepted";
}

/**
 * Save cookie consent
 */
export function saveConsent(accepted) {
  setCookie(
    CONSENT_COOKIE_NAME,
    accepted ? "accepted" : "declined",
    CONSENT_COOKIE_DAYS,
  );
}

/**
 * Get current consent status.
 * Returns "accepted", "declined", or null when no choice was made.
 */
export function getConsentStatus() {
  const status = getCookie(CONSENT_COOKIE_NAME);
  return status === "accepted" || status === "declined" ? status : null;
}
